export function extractFilesFromScreenshot(event: ClipboardEvent) {
  const clipboardData = event.clipboardData;

  if (!clipboardData) {
    return null;
  }

  const items = Array.from(clipboardData.items);
  const images = items.filter((item) => item.type.startsWith("image/"));

  if (images.length > 0) {
    event.preventDefault();

    const dataTransfer = new DataTransfer();

    images.forEach((image) => {
      if (image.kind === "file") {
        const file = image.getAsFile();

        if (file) {
          dataTransfer.items.add(file);
        }
      }
    });

    return dataTransfer.files;
  }

  return null;
}
